import { render, staticRenderFns } from "./BlueTop.vue?vue&type=template&id=39361692&lang=pug"
import script from "./BlueTop.vue?vue&type=script&lang=ts"
export * from "./BlueTop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports